export default {
  hero: {
    badge: "Our Story",
    titlePrefix: "About ",
    titleHighlight: "Us",
    subtitle: "Meet the story behind Smart Business Digital Solutions and the mission that drives us to empower Latino entrepreneurs worldwide."
  },
  story: {
    photoBadge: "Founder & CEO",
    badge: "My Story",
    title: "From Entrepreneur to",
    titleHighlight: "Digital Mentor",
    p1: "Cathy Roldán is an entrepreneur, digital mentor, and educator passionate about empowering the Latino community. With deep roots in Hispanic culture, Cathy understood early on that access to digital education could change lives.",
    p2: "She began her journey in digital marketing as a self-taught professional, mastering every tool, strategy, and platform available. What started as a personal need soon evolved into a mission: to democratize digital knowledge for Latino entrepreneurs.",
    p3: "Today, through Smart Business Digital Solutions LLC and Smart Business Academy, Cathy has helped over 500 students and 200 clients transform their businesses, increase their income, and build powerful brands in the digital world.",
    p4: "Her approach combines digital marketing strategy, artificial intelligence tools, business automation, and practical education. Everything is designed so that any entrepreneur, regardless of their technical level, can master the online world.",
    trajectoryTitle: "Trajectory",
    milestones: {
       m1: { year: "2018", title: "The Beginning", desc: "Cathy starts her career in digital marketing, teaching herself social media strategies and online business." },
       m2: { year: "2019", title: "First Clients", desc: "Starts working with small Latino businesses, helping them establish their digital presence and increase sales." },
       m3: { year: "2021", title: "Smart Business is Born", desc: "Foundations of Smart Business Digital Solutions LLC, consolidating her team and expanding digital marketing and automation services." },
       m4: { year: "2022", title: "Smart Business Academy", desc: "Launches the online academy for Latino entrepreneurs, democratizing access to quality digital education." },
       m5: { year: "2024", title: "Global Impact", desc: "Over 500 students and 200 clients across Latin America and the United States, with a presence on multiple digital platforms." }
    }
  },
  missionVision: {
    mission: {
      label: "Mission",
      title: "Empowering Latino Entrepreneurs",
      text: "Our mission is to empower Latino entrepreneurs and business owners worldwide by providing them with the tools, strategies, and knowledge in digital marketing and artificial intelligence necessary to build profitable and sustainable businesses in the digital age."
    },
    vision: {
      label: "Vision",
      title: "Leaders in the Latino Digital World",
      text: "To be the most influential digital marketing and online education company for the Latino community, creating an ecosystem where every Hispanic entrepreneur has access to the same digital opportunities as global business leaders."
    },
    valuesTitle: "Our Values",
    valuesHighlight: "Defines",
    valuesSub: "What ",
    items: {
      community: { title: "Community", desc: "We believe in the power of the Latino community and work to strengthen every business that is a part of it." },
      innovation: { title: "Innovation", desc: "We adopt the latest IA and digital marketing technologies to keep our clients at the forefront." },
      integrity: { title: "Integrity", desc: "We work with transparency and honesty, always prioritizing our clients' true success." },
      results: { title: "Results", desc: "We focus on real metrics: more followers, more sales, more income for your business." }
    },
    experienceTitle: "Experience & Specialties",
    areas: {
      marketing: "Digital Marketing",
      tech: "Technology & AI",
      education: "Education & Coaching"
    }
  }
};
